import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '@/lib/api';

const WorkspaceContext = createContext(null);
const LS_KEY = 'active_workspace_id';

export function WorkspaceProvider({ children }) {
  const [workspaces, setWorkspaces] = useState([]);
  const [activeId, setActiveId] = useState(() => localStorage.getItem(LS_KEY) || null);
  const [loaded, setLoaded] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get('/workspaces');
      const list = Array.isArray(data) ? data : [];
      setWorkspaces(list);
      setActiveId(prev => (prev && list.some(w => w.id === prev)) ? prev : (list[0]?.id || null));
    } catch { /* offline or pre-migration backend: stay workspace-less */ }
    setLoaded(true);
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  useEffect(() => {
    if (activeId) localStorage.setItem(LS_KEY, activeId);
  }, [activeId]);

  const active = workspaces.find(w => w.id === activeId) || null;

  return (
    <WorkspaceContext.Provider value={{ workspaces, active, activeId, setActiveId, refresh, loaded, multi: workspaces.length > 1 }}>
      {children}
    </WorkspaceContext.Provider>
  );
}

export function useWorkspace() {
  return useContext(WorkspaceContext) || { workspaces: [], active: null, activeId: null, setActiveId: () => {}, refresh: () => {}, loaded: false, multi: false };
}
